/**
 * Interval for open-thread message refresh only.
 * Conversation lists are not polled — they refresh via WebSocket + user actions.
 */
export const OMNICHANNEL_POLL_INTERVAL_MS = 30_000;
